import type { DataFetchParams } from '@/components/DataTable';
import { ORG_EXTENSION_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/extensions';

const USER_FIELD = ORG_EXTENSION_FILTERABLE_FIELDS.USER;

/**
 * Strip a persisted `user` filter from the org-extensions params when the viewer
 * can't filter by user (member). The Users filter's options come from the org
 * members list — an endpoint RBAC-gated to owner/manager — so for members the
 * column is rendered non-filterable (KIR-3266). This guards the second surface
 * the column gate alone misses: a stale `user` filter carried in URL state from
 * a prior owner/manager session would otherwise rehydrate and reach
 * `fetchOrgExtensions` as a query param. Mirrors `sanitizeAlertsParams`
 * (KIR-3266 CR — defense-in-depth, GiorgeCh).
 *
 * Only the filter is stripped; the Users column stays sortable for members
 * (sort-by-userCount does not hit the members endpoint). When `canFilterByUser`
 * the params pass through untouched (same reference).
 */
export function sanitizeOrgExtensionParams(
  params: DataFetchParams,
  canFilterByUser: boolean
): DataFetchParams {
  if (canFilterByUser) return params;
  const filters = params.filters.filter(f => f.field !== USER_FIELD);
  return { ...params, filters };
}
